export { default as VerticalVideoGallery } from './VerticalVideoGallery';
export type { VerticalVideoGalleryProps } from './VerticalVideoGallery';
